import { useEffect, useMemo, useState } from "react";
import { getPosicionUnidades, getServiciosUnidades } from "./integracionPanel";
import { Tooltip } from "@mui/material";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
const getStatusDesign = (status) => {
    switch (status) {
        case "EN SERVICIO":
            return { tagColor: "#e03e3e", gradient: "linear-gradient(to right, #ff999933, #ff666611)" };
        case "NO CONFIRMADA, INICIA EN":
            return { tagColor: "#ff4d4f", gradient: "linear-gradient(to right, #FFB7A633, #FF998011)" };

        default:
            return "";
    }
};
const todosLosEstatus = [
    { name: "EN SERVICIO", code: 1 },
    { name: "SIN SERVICIO", code: 2 },

];
const ListaPorUnidades = ({
    listaRutasPanelIzquierdoUnidad,
    setListaRutasPanelIzquierdoUnidad,
    contadorPorMinuto,
    setCentrarUnidad,
    zona,
    activeIndex,
    unidades,
    setCoordenadasVistaUnidades,
    coordenadasVistaUnidades,
    unidadCoordenadas,
    setDataUnidadVistaUnidad
}) => {

    const [filtro, setFiltro] = useState("");
    const [estatusSeleccionados, setEstatusSeleccionados] = useState([]);
    const [serviciosUnidades, setServiciosUnidades] = useState([]);
    
    
   
    
    useEffect(() => {
        if (activeIndex == 1) {
            getServiciosUnidades(setServiciosUnidades)
        }
    }, [contadorPorMinuto, zona, activeIndex]);

   

    const datosFiltrados = useMemo(() => {

        let resultados = serviciosUnidades;

        if (filtro.trim()) {
            const query = filtro.toLowerCase();
            
            resultados = resultados.filter(
                (d) =>
                    d.UNIDAD?.toString().toLowerCase().includes(query) ||
                    d.TIPO?.toLowerCase().includes(query) ||
                    d.ESTATUS?.toLowerCase().includes(query) ||
                    d.ESTADO_UNIDAD?.toLowerCase().includes(query)||
                    d.RUTA?.toLowerCase().includes(query)
            );
          
        }

        if (estatusSeleccionados.length > 0) {
            const codigosSeleccionados = estatusSeleccionados.map((e) => e.name);
          
            
            resultados = resultados.filter((d) =>
                codigosSeleccionados.includes(String(d.ESTADO_UNIDAD))
            );
           
        }

       
        return resultados;
    }, [filtro, estatusSeleccionados, serviciosUnidades]);

    const toggleSelection = (item) => {
      

        const isSelected = listaRutasPanelIzquierdoUnidad.some(
            (selectedItem) => selectedItem.UNIDAD === item.UNIDAD
        );
        if (isSelected) {
            setListaRutasPanelIzquierdoUnidad(
                listaRutasPanelIzquierdoUnidad.filter(
                    (selectedItem) => selectedItem.UNIDAD !== item.UNIDAD
                ));
        } else {
            setListaRutasPanelIzquierdoUnidad([...listaRutasPanelIzquierdoUnidad, item]);

        }
    };

    const itemTemplate = (item) => {
        if (!item) {
            return null;
        }
        
        const isSelected = listaRutasPanelIzquierdoUnidad.some(
            (selectedItem) => selectedItem.UNIDAD === item.UNIDAD
        );

        // Estilos dinámicos para elementos seleccionados
        const itemStyle = {
            background: isSelected ? "linear-gradient(to right, #007ad933, #0056b311)" : "transparent",
            border: isSelected ? "2px solid #007ad9" : "2px solid #0056b311",
            position: "relative"

        };

        const findCordsUnidad = (id_unidad) => {
           

            // PRIMERO: Asegurarse de que la unidad esté en la lista para obtener coordenadas
            const unidadSeleccionada = serviciosUnidades.find(u => u.UNIDAD == id_unidad);
            if (unidadSeleccionada) {
                // Verificar si ya está en la lista
                const yaEstaEnLista = listaRutasPanelIzquierdoUnidad.some(item => item.UNIDAD === id_unidad);
                if (!yaEstaEnLista) {
                    
                    setListaRutasPanelIzquierdoUnidad(prev => [...prev, unidadSeleccionada]);
                }
            }

            // SEGUNDO: Buscar en las coordenadas existentes
            const unidad = unidadCoordenadas?.find(u => u.UNIDAD == id_unidad);
            if (unidad && unidad.coordenadas && unidad.coordenadas.lat && unidad.coordenadas.lng) {
                // Las coordenadas ya vienen como objeto {lat, lng}
                const coordsObject = {
                    lat: unidad.coordenadas.lat, 
                    lng: unidad.coordenadas.lng
                };
              
                setCentrarUnidad(coordsObject);
            } 

            // Actualizar la información de la unidad seleccionada en el panel de propiedades
            setDataUnidadVistaUnidad(item);
        }


        return (
            <div
                className={`item-row ${isSelected ? 'selected' : ''}`}
                onClick={() => { findCordsUnidad(item.UNIDAD); }}
                style={itemStyle}
            >
                {/* Ícono de selección */}
                {isSelected ?
                    <div className="selection-indicator" onClick={() => toggleSelection(item)}>
                        <i className="pi pi-check-circle" style={{
                            color: "#007ad9",
                            fontSize: "1.2rem",
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "white",
                            borderRadius: "50%",


                        }}></i>


                    </div>
                    :
                    <div className="selection-indicator" onClick={() => toggleSelection(item)}>
                        <i className="pi pi-circle" style={{
                            color: "#007ad9",
                            fontSize: "1.2rem",
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            backgroundColor: "white",
                            borderRadius: "50%",

                        }}></i>


                    </div>
                }

                <div className="item-ruta">{item.RUTA}</div>
                <div className="item-unidad">Unidad: {item.UNIDAD}</div>
                <Tag
                    value={item.ESTADO_UNIDAD}
                    className="item-estatus"
                    style={{
                        backgroundColor: item.ESTADO_UNIDAD === 'EN SERVICIO' ? '#004da5ff' : '#ff4d4f',
                        color: "#fff",
                        // Ajustar opacidad si está seleccionado para mejor contraste
                        opacity: isSelected ? 0.9 : 1
                    }}
                />
            </div>
        );
    };
    return (
        <div className="tableroListaDeServicios">
            <div className="filtros">
                <InputText
                    placeholder="Buscar por texto..."
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                    className="w-full"
                />
                <MultiSelect
                    value={estatusSeleccionados}
                    options={todosLosEstatus}
                    optionLabel="name"
                    onChange={(e) => setEstatusSeleccionados(e.value)}
                    placeholder="Filtrar por estatus"
                    className="w-full"
                    display="chip"
                    maxSelectedLabels={0}
                />

                <div className="filtros">
                    <Tooltip title='Desmarcar todo'>
                        <Button label="" icon={'pi pi-minus-circle'} style={{ marginTop: "10px" }} onClick={() => { setListaRutasPanelIzquierdoUnidad([]) }}></Button>
                    </Tooltip>
                </div>
            </div>
            
            {/* Lista principal con scroll personalizado */}
            <div 
                style={{ 
                    height: "calc(100vh - 250px)", 
                    overflow: "auto", 
                    
                }}
                className="custom-scrollbar"
            >
                {datosFiltrados.map((item, index) => (
                    <div key={item.UNIDAD || index}>
                        {itemTemplate(item)}
                    </div>
                ))}
                {datosFiltrados.length === 0 && (
                    <div style={{ 
                        padding: "40px", 
                        textAlign: "center", 
                        color: "#999",
                        fontSize: "16px"
                    }}>
                        No hay unidades para mostrar
                    </div>
                )}
            </div>
        </div>
    )
}
export default ListaPorUnidades